import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M3.25 4a.25.25 0 0 1 .25-.25h5.649l2.5 3H20.5a.25.25 0 0 1 .25.25v3.25H3.25zm0 7.75V20c0 .138.112.25.25.25h17a.25.25 0 0 0 .25-.25v-8.25zm.25-9.5A1.75 1.75 0 0 0 1.75 4v16c0 .966.784 1.75 1.75 1.75h17A1.75 1.75 0 0 0 22.25 20V7a1.75 1.75 0 0 0-1.75-1.75h-8.149l-2.5-3z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }